var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Linkedin",
    clipPath: "url(#clip0_118_506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9187 22.9277H19.5875V17.7064C19.5875 16.4614 19.5625 14.8589 17.85 14.8589C16.1137 14.8589 15.8488 16.2139 15.8488 17.6152V22.9277H12.5162V12.1914H15.7162V13.6539H15.76C16.2075 12.8114 17.295 11.9202 18.92 11.9202C22.295 11.9202 22.92 14.1427 22.92 17.0339V22.9277H22.9187ZM8.75375 10.7227C8.49944 10.723 8.24757 10.6731 8.01258 10.5759C7.77758 10.4787 7.56408 10.3361 7.38432 10.1562C7.20456 9.97632 7.06207 9.76273 6.96501 9.52767C6.86796 9.29261 6.81826 9.04071 6.81875 8.78641C6.819 8.4037 6.93272 8.02966 7.14555 7.71159C7.35838 7.39352 7.66074 7.1457 8.01441 6.99947C8.36808 6.85324 8.75717 6.81518 9.13248 6.89008C9.50778 6.96499 9.85244 7.1495 10.1229 7.42029C10.3933 7.69108 10.5774 8.03598 10.6518 8.41138C10.7262 8.78678 10.6877 9.17582 10.541 9.5293C10.3943 9.88278 10.1461 10.1848 9.82774 10.3972C9.50939 10.6097 9.13521 10.7229 8.7525 10.7227H8.75375ZM10.4237 22.9277H7.0825V12.1914H10.425V22.9277H10.4237ZM24.5875 3.75391H5.41125C4.49125 3.75391 3.75 4.47891 3.75 5.37516V24.6327C3.75 25.5289 4.4925 26.2539 5.41 26.2539H24.5825C25.5 26.2539 26.25 25.5289 26.25 24.6327V5.37516C26.25 4.47891 25.5 3.75391 24.5825 3.75391H24.5863H24.5875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.deadbcf3ae30ebe77a38330492badb1b.svg";
export { ForwardRef as ReactComponent };